// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "seasonal-picks" + "." + "898d6746" + ".css";
};